import {Component} from '@angular/core';
import {MainComponent} from '../main/main.component';
import {BrokerInformationSectionComponent} from './broker-information/broker-information-section.component';
import {HumaniaSectionComponent} from './humania-section/humania-section.component';
import {PasswordComponent} from './password/password.component';

@Component({
  selector: 'em-profile-page',
  templateUrl: './profile-page.component.html',
  imports: [MainComponent, BrokerInformationSectionComponent, PasswordComponent, HumaniaSectionComponent],
})
export class ProfilePageComponent {}
